<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectInput
        :question="$t('buttons.question')"
        :selections="[
          {
            image: require('@/assets/classic-button.png'),
            name: $t('buttons.classic'),
            value: 'classic'
          },
          {
            image: require('@/assets/regular-button.jpg'),
            name: $t('buttons.regular'),
            value: 'regular'
          },
          {
            image: require('@/assets/premium-button.jpg'),
            name: $t('buttons.premium'),
            value: 'premium'
          }
        ]"
        :selected-value="buttons"
        :clicked-callback="onSelect"
      ></SelectInput>
      <a @click="$router.push(getPrevStepUrl(step))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import SelectInput from "../../components/SelectInput";
import { mapMutations } from "vuex";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "Buttons",
  components: { CalculatorHeading, SelectInput },
  data() {
    return {
      step: getStepIndex("buttons"),
      getPrevStepUrl: getPrevStepUrl,
      buttons: this.$store.state.data.buttons
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateButtons"]),
    onSelect(value) {
      this.buttons = value;
      this.updateButtons(value);
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>
